import {h, Fragment} from "preact"
import { SerpElement } from '@nosto/preact'
import { formatCurrency, getLowestPricedSku } from '../helpers'
import { useEffect, useState } from 'preact/hooks'

export default ({ product, isSaleCollection, isHempDivision }) => {
    let hasAltImage = (product?.alternateImageUrls?.length) && (product?.alternateImageUrls[0] !== null);
    let priceVaries = product.skus?.some(sku => sku.availability === 'InStock' && sku?.price !== product.price);
    let lowestPrice = product.skus?.reduce((obj, sku) => {
        return (sku.availability === 'InStock' && sku?.price < obj.price) ? sku : obj;
    }, product);
    const [isPromo, setIsPromo] = useState(false);

    if(document.querySelector("#ns-ocp")){
        setTimeout(() => {
            let promoCategories = window.nostoCategories;
            if(promoCategories){
                product.categories.forEach((cat) => {
                    if(promoCategories.includes(cat.toLowerCase())){
                        setIsPromo(true);
                    }
                })
            }
        }, 750)
    }
    
    if(isSaleCollection && !(lowestPrice?.listPrice > lowestPrice?.price)) {
        lowestPrice = getLowestPricedSku(product.skus) || product;
        priceVaries = false;
    }

    const discount = (lowestPrice && lowestPrice?.listPrice > lowestPrice.price) &&
        Math.round(((lowestPrice.listPrice - lowestPrice.price) / lowestPrice.listPrice) * 100) || 0;

//console.log('p', discount, product)
    const availableSkus = product.skus?.filter(sku => sku.availability === "InStock");

    if(window.noHover) {
        hasAltImage = false;
    }

    return (
        <SerpElement
            as="product-item"
            hit={product}
            class={`product-item ${product.availability === 'OutOfStock' ? "product-item--sold-out" : ""}`}
        >
            <div class={`product-item__image-wrapper ${hasAltImage ? 'product-item__image-wrapper--multiple' : ''}`}>
                <div class="product-item__label-list label-list">
                    {product.availability === 'OutOfStock'
                        ?   <span class="label label--subdued">Sold out</span>
                        :   discount !== 0 && product.skus?.[0]?.customFields?.find(f => f.key === 'custom-final_sale_')?.value === 'final sale'
                            ?   <span class="label label--highlight">Final Sale</span>
                            :    discount !== 0
                                ?   <span class="label label--highlight">Save {discount}%</span>
                                :   product.tags1?.includes('new-product')
                                    ?   <span class="label label--custom">New</span>
                                    :   product.categories?.includes("Mike Harney's Selects") || product.categories?.includes("Paul Harney's Selects") || product.categories?.includes("Emeric Harney's Selects")
                                        ?   <span class="label label--custom" style="background: #000; color: rgb(224 191 102)">                                        
                                            Harney Favorite
                                            </span>
                                    :   null
                    }
                    {(discount == 0 && isPromo) && <span class="label label--highlight">{promoElem}</span>}
                </div>
                <a href={product.url} class="product-item__aspect-ratio aspect-ratio" style="padding-bottom: 114.5945945945946%; --aspect-ratio: 0.8726415094339622;">
                    <img
                        alt={product.name}
                        src={product.imageUrl} 
                        srcset={`${product.imageUrl?.replace('.jpg', '_200x.jpg')} 200w, 
                            ${product.imageUrl?.replace('.jpg', '_300x.jpg')} 300w, 
                            ${product.imageUrl?.replace('.jpg', '_400x.jpg')} 400w, 
                            ${product.imageUrl?.replace('.jpg', '_500x.jpg')} 500w, 
                            ${product.imageUrl?.replace('.jpg', '_600x.jpg')} 600w, 
                            ${product.imageUrl?.replace('.jpg', '_700x.jpg')} 700w, 
                            ${product.imageUrl?.replace('.jpg', '_800x.jpg')} 800w, 
                            ${product.imageUrl?.replace('.jpg', '_900x.jpg')} 900w, 
                            ${product.imageUrl?.replace('.jpg', '_1000x.jpg')} 1000w, 
                            ${product.imageUrl?.replace('.jpg', '_1100x.jpg')} 1100w`} 
                        sizes="(max-width: 740px) 50vw, min(25vw, 304px)" 
                        class="product-item__primary-image"
                        loading="lazy" />
                    {hasAltImage &&
                        <img
                            alt={product.name}
                            src={product.alternateImageUrls[0]} 
                            srcset={`${product.alternateImageUrls[0]?.replace('.jpg', '_200x.jpg')} 200w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_300x.jpg')} 300w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_400x.jpg')} 400w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_500x.jpg')} 500w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_600x.jpg')} 600w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_700x.jpg')} 700w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_800x.jpg')} 800w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_900x.jpg')} 900w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_1000x.jpg')} 1000w, 
                                ${product.alternateImageUrls[0]?.replace('.jpg', '_1100x.jpg')} 1100w`} 
                            sizes="(max-width: 740px) 50vw, min(25vw, 304px)" 
                            class="product-item__secondary-image"
                            loading="lazy" />
                    }
                </a>
                {(!isHempDivision && product.availability !== 'OutOfStock' && product?.skus?.length === 1 && !product.tags1?.find(tag => tag === 'The Hemp Division')) ? (
                    <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__quick-form" enctype="multipart/form-data" is="product-form">
                        <input type="hidden" name="form_type" value="product"/>
                        <input type="hidden" name="utf8" value="✓" />
                        <input type="hidden" name="quantity" value="1" />
                        <input type="hidden" name="id" value={product?.skus.length ? product?.skus[0]?.id : product.productId} />
                        <button is="loader-button" type="submit" class="button button--outline button--text button--full hidden-touch">
                            <span class="loader-button__text">+ Add to Cart</span>
                            <span class="loader-button__loader" hidden>
                                <div class="spinner">
                                    <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg>
                                </div>
                            </span>
                        </button>
                        <button type="submit" class="product-item__quick-buy-button hidden-no-touch">
                            <span class="visually-hidden">+ Add to Cart</span>
                            <svg focusable="false" width="24" height="24" class="icon icon--quick-buy-shopping-bag" fill="none" viewBox="0 0 24 24"><path d="M14 4H5L4 20H20C19.7517 16.0273 19.375 10 19.375 10" stroke="currentColor" stroke-width="1.2"></path><path d="M9 7V7C9 8.65685 10.3431 10 12 10V10C13.6569 10 15 8.65685 15 7V7" stroke="currentColor" stroke-width="1.2"></path><path d="M20 0V8M16 4H24" stroke="currentColor" stroke-width="1.2"></path></svg>
                        </button>
                    </form>
                ) : (product.availability !== 'OutOfStock' && availableSkus?.length > 1) ? (
                    // <>
                    //     <div class="product-item__quick-form">
                    //         <button is="toggle-button" loader="" aria-controls={`ns-quickbuy-drawer-${product.productId}`} aria-expanded="false" class="button button--outline button--text button--full  hidden-touch hidden-phone">
                    //             <span class="loader-button__text">Quick View</span>
                    //             <span class="loader-button__loader" hidden="">
                    //                 <div class="spinner">
                    //                     <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg>
                    //                 </div>
                    //             </span>
                    //         </button>
                    //         <button is="toggle-button" aria-controls={`ns-quickbuy-drawer-${product.productId}`} aria-expanded="false" class="product-item__quick-buy-button hidden-no-touch hidden-phone">
                    //             <span class="visually-hidden">Quick View</span>
                    //             <svg focusable="false" width="24" height="24" class="icon icon--quick-buy-shopping-bag" fill="none" viewBox="0 0 24 24"><path d="M14 4H5L4 20H20C19.7517 16.0273 19.375 10 19.375 10" stroke="currentColor" stroke-width="1.2"></path><path d="M9 7V7C9 8.65685 10.3431 10 12 10V10C13.6569 10 15 8.65685 15 7V7" stroke="currentColor" stroke-width="1.2"></path><path d="M20 0V8M16 4H24" stroke="currentColor" stroke-width="1.2"></path></svg>
                    //         </button>
                    //         <button is="toggle-button" aria-controls={`ns-quickbuy-popover-${product.productId}`} aria-expanded="false" class="product-item__quick-buy-button hidden-tablet-and-up">
                    //             <span class="visually-hidden">Quick View</span>
                    //             <svg focusable="false" width="24" height="24" class="icon icon--quick-buy-shopping-bag" fill="none" viewBox="0 0 24 24"><path d="M14 4H5L4 20H20C19.7517 16.0273 19.375 10 19.375 10" stroke="currentColor" stroke-width="1.2"></path><path d="M9 7V7C9 8.65685 10.3431 10 12 10V10C13.6569 10 15 8.65685 15 7V7" stroke="currentColor" stroke-width="1.2"></path><path d="M20 0V8M16 4H24" stroke="currentColor" stroke-width="1.2"></path></svg>
                    //         </button>
                    //     </div>
                    //     <quick-buy-popover href={`${product.url}?view=quick-buy-popover`} id={`ns-quickbuy-popover-${product.productId}`} class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>
                    //     <quick-buy-drawer href={`${product.url}?view=quick-buy-drawer`} id={`ns-quickbuy-drawer-${product.productId}`} class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>
                    // </>
                    <div class="product-item__quick-form">
                        <select class="product-item__cta--options product-item__cta button button--primary" name="" defaultValue="default" onChange={e => window.nosto.addingToCart(product.productId, e.target.value, null)}>
                            <option disabled hidden value="default">
                                <span class="loader-button__text">Select Option</span>
                                <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m21 3.998c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm6.75 6.752h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75z" fill-rule="nonzero" fill="#FFFFFF"/></svg>
                            </option>
                            {availableSkus?.map(sku => {
                                return (
                                    <option key={sku.id} value={sku.id} >{sku.name} ({formatCurrency(sku.price)})</option>
                                )
                            }
                            )}
                        </select>
                    </div>
                ) : ( 
                    null 
                )}
            </div>
            <div class="product-item__info">
                <div class="product-item-meta">
                    <a href={product.url} class="product-item-meta__title">{product.name}</a>
                    <div class="klaviyo-star-rating-widget" data-id={`${product.productId}`} style="display: inline-block;"></div>	
                    <div class="product-item-meta__price-list-container">
                        <div class="price-list price-list--centered">
                            {(lowestPrice && lowestPrice?.listPrice > lowestPrice?.price) ? (
                                <>
                                    {priceVaries && 
                                        <small style="margin-right: 4px;"><em>from</em></small>
                                    }
                                    <span class="price price--highlight">
                                        <span class="visually-hidden">Sale price</span>
                                        {formatCurrency(lowestPrice?.price)}
                                    </span>
                                    <span class="price price--compare">
                                        <span class="visually-hidden">Regular price</span>
                                        {formatCurrency(lowestPrice?.listPrice)}
                                    </span>
                                </>
                            ) : (
                                <span class="price">
                                    <span class="visually-hidden">Regular price</span>
                                    {priceVaries && 
                                        <small style="margin-right: 4px;"><em>from</em></small>
                                    }
                                    {formatCurrency(lowestPrice?.price)}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}
